<template>
  <v-sheet
    :dark="dark"
    class="fill-height py-15"
    :color="!dark ? 'background' : null"
  >
    <page-header
      :back="redir"
      title="Instellingen"
      icon="settings"
      :collapseToolbar="true"
    >
    </page-header>
    <address-block popup show-add hide-hubs title="Addressbeheer"
              allow-delete 
              :show="showAddress"
              @update="reLoad()"
             
              @close="showAddress = false;reLoad()"
            
            >
            </address-block>
    <v-card-text v-if="!user" class="main-content">
        <v-card-title class="primary--text">Aanmelden</v-card-title>
        <phone-validator class="pl-0" dense ref="phonecheck" v-model="phone" @valid="reLoad"></phone-validator>
        Geef je telefoonnummer waarom we je kunnen bereiken
    </v-card-text>
  <v-card-text v-else class="main-content">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title class="primary--text">Gegevens</v-card-title>
      <v-card class="mx-auto" outlined>
        <v-card-text class="pl-5">
          <v-row>
            <v-col cols="12">
          <v-text-field
            v-model="name"
            :rules="[$config.rules.required, $config.rules.min2]"
            :autofocus="name ? false : true"  
            label="Naam"
            prepend-icon="person_outline"
          ></v-text-field>
          </v-col>
          <v-col cols="3" v-if="false">
          <v-avatar-upload class="ml-4"
                                                              title="Foto"
                                                                v-model="avatar"
                                                              />
          </v-col>
          </v-row>
          
          <phone-validator class="pl-0" dense ref="phonecheck" icon="phone" v-model="phone" @reset="resetState" @valid="load"></phone-validator>
        </v-card-text>
      </v-card>
    </v-form>
    <template >
    <v-card-title class="mt-4 primary--text">Adres
      <v-spacer></v-spacer>
      <v-btn @click="showAddress = true" icon color="primary"><v-icon>mdi-plus</v-icon></v-btn>
    </v-card-title>
    
      <v-card class="mx-auto" outlined v-if="addressList.length>0">
      
          <v-list class="py-0">
            <v-list-item-group active-class="primary--text">
                    <template v-for="addr in addressList">
                      <v-list-item  :value="addr"
                        :key="addr.name" @click="address=addr"
                      >
                        <v-list-item-icon class="mr-3"

                          ><v-icon v-if="address && addr.name==address.name" color="primary">check</v-icon>
                          <v-icon v-else-if="addr.current">location_on</v-icon
                          ><v-icon v-else>home</v-icon></v-list-item-icon
                        >
                        <v-list-item-content>
                          
                          <v-list-item-title>{{
                            addr.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle v-if="addr.current">Huidige locatie</v-list-item-subtitle>
                        </v-list-item-content>
                       <v-list-item-action>
                          <v-btn icon @click="removeAddress(addr)"
                            ><v-icon small>delete</v-icon></v-btn
                          >
                        </v-list-item-action>
                        </v-list-item>
                      
                    </template>
            </v-list-item-group>
                </v-list>
                <address-select
                v-if="showAddress"
                prepend-icon="arrow_back"
                show
                :autofocus="true"
                class="mt-3"
                v-model="newAddress"
                :dark="dark"
                @select="addAddress"
                @cancel="showAddress = false"
              >
              </address-select>
      </v-card>
    </template>

    <template v-if="favorites.length > 0">
      <v-card-title class="mt-4 primary--text">Favorieten</v-card-title>
      <v-card class="mx-auto" outlined>
        <v-list>
          <v-list-item v-for="(host, i) in favorites" :key="i">
             <v-list-item-avatar v-if="host.logo">
              <v-img :src="host.logo"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
            <v-list-item-title>{{ host.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="removeFavoriteHost(host)"
                ><v-icon small>delete</v-icon></v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
    <template v-if="clubs.length > 0">
      <v-card-title class="mt-4 primary--text">Verenigingen</v-card-title>
      <v-card class="mx-auto" outlined>
        <v-list>
          <v-list-item v-for="(host, i) in clubs" :key="i">
             <v-list-item-avatar v-if="host.logo">
              <v-img :src="host.logo"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
            <v-list-item-title>{{ host.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="removeFavoriteClub(host, true)"
                ><v-icon small>delete</v-icon></v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
    

     <v-card-title v-if="courier" class="primary--text mt-4 pb-0">{{$t('Menu.fetch')}}</v-card-title>
    <v-list-item :class="{'mt-4': !courier}">
                        
                        <v-list-item-content>
                          
                          <v-list-item-title>Ik doe mee aan de ophaalservice</v-list-item-title>
                        </v-list-item-content>
                       <v-list-item-action>
                          <v-switch
                        v-model="courier"
                        
                      ></v-switch>
                        </v-list-item-action>
                        </v-list-item>
   
    <template v-if="courier">
     
      <v-card class="mx-auto" outlined>
        <v-list>
          <v-list-item v-for="(host, i) in delivers" :key="i">
            <v-list-item-avatar v-if="host.logo">
              <v-img :src="host.logo"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
            <v-list-item-title>{{ host.name }}</v-list-item-title>
            <v-list-item-subtitle v-if="host._verified">Sinds {{ host._verified | moment('DD-MM-yyyy') }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else>Goedkeuring afwachten</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="removeDeliverHost(host)"
                ><v-icon small>delete</v-icon></v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
  </v-card-text>
    <v-footer fixed color="transparent" class="main-content">
      <v-btn color="grey"
        plain @click="deleteMe">Verwijderen</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="save" :disabled="!valid || !validated">Opslaan</v-btn>
    </v-footer>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import PageHeader from "../components/PageHeader.vue";
import vAvatarUpload from "../components/vAvatarUpload.vue";
import headerItem from "@/modules/headerItem";
import AddressBlock from "../components/AddressBlock.vue";
import phoneValidator from "../components/phoneValidator.vue";
import AddressSelect from "../components/AddressSelect.vue";
export default {
  mixins: [headerItem],
  components: {
    PageHeader,
    AddressBlock,
    phoneValidator,
    vAvatarUpload,
    AddressSelect
  },
  data() {
    return {
      loading: true,
      valid: true,
      showAddress: false,
      showSearch: false,
      avatar: null,
      courier: false,
      name: null,
      phone: null,
      validated: false, 
      addressList: [],
      hostlist: [],
      newAddress: null,
      addresitem: null
    };
  },
  computed: {
    ...mapGetters(["user"]),
    banner() {
      return this.$config.page.banner;
    },
    redir(){
      if (this.$route.query.redir) return this.$route.query.redir
      return 'dashboard'
    },
    title() {
      return "Instellingen";
    },
    favorites() {
      let hosts = [];
      this.hostlist.map((hub) => {
        hub._hosts
          .filter((h) => h._favorite)
          .map((host) => {
            if (hosts.filter(h=>h._id==host._id).length == 0) hosts.push(host)
          });
      });
      return hosts;
    },
    delivers(){
        return this.user['#HOSTS'] || []
    },
    clubs() {
      let hosts = [];
      this.hostlist.map((hub) => {
        hub._hosts
          .filter((h) => h._favorite && h.$type == "club")
          .map((host) => hosts.push(host));
      });
      return hosts;
    },
     address: {
      get() {
        return this.$store.state.config.address || null;
      },
      set(value) {
        this.setConfig({ address: value });
      },
    },
  },

  async mounted() {
    let user = await this.reLoad()
    if (this.address) this.addressitem = this.address.name
    
  },
  watch: {
    //name: 'validateForm',
    phone(value, old){
      if (value && old) {
        this.validated = this.user._key ==value
      }
    }
  },
  methods: {
    ...mapActions(["setUser", "setConfig", "resetState", "logout"]),
    ...mapMutations(["resetState"]),
    async reLoad(){
      let response = await this.$http.get("/api/auth/me");
      let user = response.data.user
      if (!user) return this.$router.push({ name: this.redir });
      this.setUser(user);
      this.validated = user._verified ? true : false
      await this.load(user);
      return user
    },
    async load(user) {
      if (!user) user = this.user
      this.validated = user._verified ? true : false
      this.name = user.name;
      this.phone = user.phone;
      this.avatar = user.avatar;
      this.courier = user.courier;
      this.addressList = user._address || [];
      this.loading = false;
      let response = await this.$http.post("/api/host/list", {});
      this.hostlist = response.data;
      //if (this.isCustomer)
    },
    validateForm() {
      this.$refs.form.validate();
    },
    async updateMe() {
      this.loading = true;
      let response = await this.$http.get("/api/auth/me");
      if (response.data.user) this.setUser(response.data.user);
      this.loading = false;
    },
    async save() {
      this.validateForm();
      if (!this.valid) return false;
      await this.$http.put("/api/auth/update", {
        name: this.name,
        phone: this.phone,
        avatar: this.avatar,
        courier: this.courier
      });
      await this.updateMe();
      this.$router.push({ name: this.redir });
    },
    async deleteMe(){
      if (
        await this.$root.$confirm(
          this.name || this.phone,
          "Als je doorgaat wordt je account verwijderd met alle gegevens en bestellingen , wil je doorgaan?",
          { yes: "Ja", cancel: "Nee" }
        )
      ) {
        const resp = await this.$http.delete("/api/auth/" + this.phone)
        this.logout()
      }
    },
    async addAddress(address) {
      let aa = this.clone(address);
      delete aa.current;
      aa._key = (
        aa.zipcode.replace(/ /g, "") +
        aa.number +
        (aa.addition ? aa.addition : "")
      ).replace(/ /g, "");
      if (this.user)
        await this.$http.post("/api/edge/ADDRESS/" + this.user._id, aa);
      this.address = aa
      this.addressList.push(aa);
    },
    async removeAddress(address) {
      await this.$http.delete("/api/edge/ADDRESS/" + this.user._id, {
        _id: address._id,
      });
      this.addressList = this.addressList.filter(a=>a._id!=address._id)
    },
    async removeFavoriteClub(club) {
      await this.$http.delete("/api/edge/CONSUMERS/" + club._id, {
        _id: this.user._id,
      });
      this.load();
    },
    async removeDeliverHost(host)  {
      if (
        await this.$root.$confirm(
          host.name,
          "Als je doorgaat wordt " +
            host.name +
            " uit je lijst gehaald en gaan je favoriete bestellingen verloren, wil je doorgaan?",
          { yes: "Ja", cancel: "Nee" }
        )
      ) {
        await this.$http.delete("/api/edge/CONSUMERS/" + host._id, {
          _id: this.user._id,
        });
        this.load();
      } else {
        //next(false);
      }
    },
    async removeFavoriteHost(host) {
      if (
        await this.$root.$confirm(
          host.name,
          "Als je doorgaat wordt " +
            host.name +
            " uit je lijst gehaald en gaan je favoriete bestellingen verloren, wil je doorgaan?",
          { yes: "Ja", cancel: "Nee" }
        )
      ) {
        await this.$http.delete("/api/edge/CONSUMERS/" + host._id, {
          _id: this.user._id,
        });
        this.load();
      } else {
        //next(false);
      }
    },
  },
};
</script>
<style >
.theme--dark.v-chip--active:hover::before,
.theme--dark.v-chip--active::before {
  display: none;
}
</style>
